export var RecaptchaEndpoints = {
    public: {
        verify: "/public/recaptcha/validate",
    },
};
